import ClientDetailContainer from "@/features/client-detail/containers/client-detail-container";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/app/clients/$clientId")({
  component: ClientDetailContainer,
});
